var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#0275B6",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M24.123 22.791l-3.478-3.45c2.803-3.495 2.385-8.572-.951-11.562-3.337-2.99-8.43-2.851-11.598.317-3.168 3.169-3.307 8.26-.317 11.598 2.99 3.336 8.067 3.754 11.562.95l3.45 3.45c.177.178.416.278.666.278.25 0 .49-.1.666-.277.351-.364.351-.94 0-1.304zm-10.04-2.146c-3.625 0-6.563-2.939-6.563-6.563 0-3.624 2.938-6.562 6.562-6.562s6.563 2.938 6.563 6.562c0 1.74-.692 3.41-1.923 4.64-1.23 1.231-2.9 1.923-4.64 1.923z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.df803e8dcab18467ec08e7eeb72a51fb.svg";
export { ForwardRef as ReactComponent };